<template>
  <table>
    <thead>
      <tr>
        <slot name="slot_head"/>
      </tr>
    </thead>
    <tbody>
      <slot v-for="(row, r) in rows" :item="row" :index="r"/>
      <slot name="other"/>
    </tbody>
  <tfoot>
    <slot name="foot"/>
    <tr :style="{marginBottom: 'auto',height: '-webkit-fill-available'}"><td></td></tr>
  </tfoot>
  </table>
</template>

<script>
export default {
  props: ['rows']
}
</script>

<style lang="scss" scoped>
td, th {
  border:1px solid gray;
  width:100px;
  height:30px;
}
th {
  height: 40px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.1em;
  color: #000000;
  align-items: center;
  height: 40px;
  white-space: nowrap;
}
table {
  table-layout: fixed;
  width: 100%; /* 固定寬度 */
  border-collapse: collapse;
  height: fit-content!important;
  min-height: unset!important;
}
tfoot {
  flex: 1;
  height: -webkit-fill-available;
  margin-bottom: auto;
}

td:first-child, th:first-child {
  position:sticky;
  left:0; /* 首行永遠固定於左 */
  z-index:1;
}
thead tr th {
  position:sticky;
  top:0; /* 列首永遠固定於上 */
  z-index:2;
  background-color: #fffae7;
}
thead tr {
  height: 40px;
}
tbody tr {
  height: 100px;
}
th:first-child{
  z-index:2;
}
th, td {
  border: none;
  padding-inline: 10px;
  &:nth-child(1) {
    padding-left: 32px;
  }
}
thead {
  background-color: #FFFFFF;
}
td {
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #6D6D6D;
}
</style>
